import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";

import { Input, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            contacto: '',
            domicilio: '',

            loteo_id: null,
            lote: '',
            manzana: '',
            certificadoLD: null,
            contrato: null,
            archivoContrato: null,
            nombreContrato: '',
            archivoMunicipalidad: null,
            nombreMunicipalidad: '',
            archivoAgua: null,
            nombreAgua: '',
            archivoImpuestos: null,
            nombreImpuestos: '',

            documentosEscribania: [],
            datosLoteos: [],

            propSelect: 1,
            loteoSelect: 1,

            postVariables: ['contacto', 'domicilio', 'loteo_id', 'lote', 'manzana', 'certificadoLD', 'contrato', 'archivoContrato', 'archivoMunicipalidad', 
                            'archivoAgua', 'archivoImpuestos'],
            errors: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }

    configuraciones = {};

    componentWillMount() {
        if (this.props.action === 'CREATE') {
            try {
                this.configuraciones = JSON.parse(localStorage.configuraciones);
                if (this.configuraciones) {
                    const direccion__localidad_id = this.configuraciones.localidad ? this.configuraciones.localidad.id : null;
                    this.setState({ direccion__localidad_id });
                }
            } catch(err) {
                // Sin configuracion
            }
        }
    }

    resetForm() {
        const direccion__localidad_id = this.configuraciones.localidad ? this.configuraciones.localidad.id : null;
        this.setState({
            id: null,
            contacto: '',
            domicilio: '',

            loteo_id: null,
            lote: '',
            manzana: '',
            certificadoLD: null,
            contrato: null,
            archivoContrato: null,
            nombreContrato: '',
            archivoMunicipalidad: null,
            nombreMunicipalidad: '',
            archivoAgua: null,
            nombreAgua: '',
            archivoImpuestos: null,
            nombreImpuestos: '',

            documentosEscribania: [],
            datosLoteos: [],

            propSelect: 1,
            loteoSelect: 1,
            
            errors: null,
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {
            // 'nombre': this.state.nombre,
            // 'cuit': this.state.cuit,
            // 'descripcion': this.state.descripcion,
            // 'email': this.state.email,
            // 'rubros_id': this.state.rubros,
            // 'direccion': {
            //     'direccion': this.state.direccion__direccion,
            //     'numero': this.state.direccion__numero,
            //     'piso': this.state.direccion__piso,
            //     'descripcion': this.state.direccion__descripcion,
            //     'localidad_id': this.state.direccion__localidad_id,
            // }
        };

        return data;
    }

    setData(data) {
        // if (this.props.action === 'CREATE') {
        //     return this.setState({
        //         direccion__localidad_id: data.localidad ? data.localidad.id : null
        //     });
        // }
        if (data.success) {
            this.setState(prevState => {
                prevState.id = data.id;
                prevState.contacto = data.contacto;
                prevState.domicilio = data.domicilio;
                prevState.loteo_id = (data.loteo) ? (data.loteo.id) : null;
                prevState.manzana = data.manzana;
                prevState.lote = data.lote;
                prevState.certificadoLD = data.certificadoLD;
                prevState.contrato = data.contrato;
                prevState.nombreContrato = data.nombreContrato;
                prevState.nombreMunicipalidad = data.nombreMunicipalidad;
                prevState.nombreAgua = data.nombreAgua;
                prevState.nombreImpuestos = data.nombreImpuestos;
                prevState.documentosEscribania = data.documentosEscribania;
                prevState.datosLoteos = data.datosLoteos;

                return prevState;
            });
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field, subfield) {
        let errors = this.state.errors;
        if (errors) {
            let _errors = errors[field];
            if (subfield) _errors = errors[field][subfield];
            return _errors;
        }
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nuevo Escribania",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "El Escribania ha sido creado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                getDepth: 0,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Escribania",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "El Escribania ha sido editado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
                getDepth: 1,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Escribania",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
                getDepth: 1,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Escribania",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "El Proveedor ha sido eliminado con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
                getDepth: 1,
            };
        }
    }

    descargarDocumentos = (tipo, idDato) =>{
        window.open((api.escribania.documento).replace('$id_escribania', this.state.id).replace('$tipo', tipo).replace('$idDatos', idDato));
    }

    descargarDocumentosPropietarios = (id) =>{
        window.open((api.escribania.documentoPropietario).replace('$id_escribania', this.state.id).replace('$id', id));
    }

    renderDownloadAction = (available, onClick) => {
        if (!available) return <p className="ui-inline-message">No está cargado</p>;

        return (
            <button type="button" className="ui-link-button" onClick={onClick}>
                Descargar
            </button>
        );
    }

    render() {
        let vars = this.modalVars();
        const { documentosEscribania, propSelect, loteoSelect, datosLoteos } = this.state;
        const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];

        let tabPropietariosContent = [];
        for (var i = 0; i < documentosEscribania.length; i++) {
            const x = i;
            tabPropietariosContent.push((

                <TabPane tabId={x+1}>
                    <section className="ui-modal-section">
                        <p className="ui-section-label">Datos personales</p>
                        <div className="ui-form-grid ui-form-grid-4">
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                maxLength={100}
                                label={"Apellido y Nombre"}
                                value={documentosEscribania[x].apellidoNombre}
                            />
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                maxLength={100}
                                label={"Estado Civil"}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        disabled={vars.disabled}
                                        url={api.configuracion.estadocivil}
                                        parameters={{
                                            paginationEnabled:false,
                                            sort:['nombre']
                                        }}
                                        value={documentosEscribania[x].estadoCivil}
                                    />
                                }
                            />
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                maxLength={100}
                                label={"C. P."}
                                value={documentosEscribania[x].codPostal}
                            />
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Nacionalidad"}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        disabled={vars.disabled}
                                        url={api.geograficas.nacionalidades}
                                                parameters={{
                                                    paginationEnabled:false,
                                                    sort:['nombre']
                                                }}
                                        value={documentosEscribania[x].nacionalidad}
                                    />
                                }
                            />
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Provincia"}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        disabled={vars.disabled}
                                        url={api.geograficas.provincias}
                                        parameters={{
                                            paginationEnabled:false,
                                            sort:['nombre']
                                        }}
                                        value={documentosEscribania[x].provincia}
                                    />
                                }
                            />
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Localidad"}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        disabled={vars.disabled}
                                        url={documentosEscribania[x].provincia ? api.geograficas.localidades : ''}
                                        parameters={{
                                            paginationEnabled:false,
                                            sort:['nombre'],
                                            concat:documentosEscribania[x].provincia ? `provincia=${documentosEscribania[x].provincia}` : ''
                                        }}
                                        value={documentosEscribania[x].localidad}
                                    />
                                }
                            />
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                maxLength={100}
                                label={"Tipo Doc."}
                                value={documentosEscribania[x].tipoDocumento}
                            />
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                maxLength={100}
                                label={"Nro Doc."}
                                value={documentosEscribania[x].dni}
                            />
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                maxLength={100}
                                label={"Cuit"}
                                value={documentosEscribania[x].cuit}
                            />
                        </div>
                    </section>

                    <section className="ui-modal-section">
                        <p className="ui-section-label">Domicilio y contacto</p>
                        <div className="ui-form-grid">
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                maxLength={100}
                                label={"Domicilio"}
                                value={documentosEscribania[x].domicilio}
                            />
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                maxLength={100}
                                label={"N°"}
                                value={documentosEscribania[x].numero}
                            />
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                maxLength={100}
                                label={"Piso"}
                                value={documentosEscribania[x].piso}
                            />
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                maxLength={100}
                                label={"Departamento"}
                                value={documentosEscribania[x].departamento}
                            />
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                maxLength={100}
                                label={"Contacto"}
                                value={documentosEscribania[x].contacto}
                            />
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                maxLength={100}
                                label={"Contacto Alternativo"}
                                value={documentosEscribania[x].contactoAlt}
                            />
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                maxLength={100}
                                label={"Relacion Titular"}
                                value={documentosEscribania[x].relacionTit}
                            />
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Constancia"}
                                inputComponent={
                                    this.renderDownloadAction(
                                        documentosEscribania[x].archivoConstancia != null,
                                        () => this.descargarDocumentosPropietarios(documentosEscribania[x].id)
                                    )
                                }
                            />
                        </div>
                    </section>
                </TabPane>
            ));
        }

        let tabLoteosContent = [];
        for (var i = 0; i < datosLoteos.length; i++) {
            const y = i;
            tabLoteosContent.push((

                <TabPane tabId={y+1}>
                    <section className="ui-modal-section">
                        <p className="ui-section-label">Antecedentes del dominio</p>
                        <div className="ui-form-grid">
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Loteo"}
                                error={() => this.getError('loteo_id')}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        clearable={false}
                                        url={api.loteos.loteos_select}
                                        parameters={{
                                            paginationEnabled:false,
                                                sort:['nombre']
                                        }}
                                        disabled={vars.disabled}
                                        value={datosLoteos[y].loteo}
                                        // onChange={e=> this.setState({loteo_id: (e.id) ? (e.id) : null, error:errors})}
                                    />
                                }
                            />
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Manzana"}
                                error={() => this.getError('manzana')}
                                value={datosLoteos[y].manzana}
                                maxLength={100}
                                disabled={vars.disabled}
                                // onChange={(e) => this.onChangeField('manzana', e.target.value)}
                            />
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Lote"}
                                error={() => this.getError('lote')}
                                value={datosLoteos[y].lote}
                                maxLength={100}
                                disabled={vars.disabled}
                                // onChange={(e) => this.onChangeField('lote', e.target.value)}
                            />
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Cert. Libre D."}
                                error={() => this.getError('certificadoLD')}
                                inputComponent={
                                    <Input
                                        type={'select'}
                                        value={datosLoteos[y].certificadoLD}
                                        className="form-control"
                                        disabled={vars.disabled}
                                        // onChange={(e) => this.onChangeField('certificadoLD', (e.target.value=='true') ? (true) : ((e.target.value=='false') ? (false) : (null)))}
                                        >
                                            <option value={'null'}>Seleccionar</option>
                                            <option value={true}>Si</option>
                                            <option value={false}>No</option>
                                    </Input>}
                            />
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Contrato"}
                                error={() => this.getError('contrato')}
                                inputComponent={
                                    <Input
                                        type={'select'}
                                        value={datosLoteos[y].contrato}
                                        disabled={vars.disabled}
                                        // onChange={(e) => this.onChangeField('contrato', (e.target.value=='true') ? (true) : ((e.target.value=='false') ? (false) : (null)))}
                                        className="form-control"
                                        >
                                            <option value={'null'}>Seleccionar</option>
                                            <option value={1}>Fideicomiso</option>
                                            <option value={2}>Boleto de compraventa</option>
                                            <option value={3}>Cesión de derechos</option>
                                    </Input>}
                            />
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Archivo Contrato"}
                                inputComponent={
                                    this.renderDownloadAction(
                                        datosLoteos[y].archivoContrato != null,
                                        () => this.descargarDocumentos(1, datosLoteos[y].id)
                                    )
                                }
                            />
                        </div>
                    </section>

                    <section className="ui-modal-section">
                        <p className="ui-section-label">Pagos de los tributos</p>
                        <div className="ui-form-grid ui-form-grid-3">
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Archivo Municipalidad"}
                                inputComponent={
                                    this.renderDownloadAction(
                                        datosLoteos[y].archivoMunicipalidad != null,
                                        () => this.descargarDocumentos(2, datosLoteos[y].id)
                                    )
                                }
                            />
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Archivo Agua"}
                                inputComponent={
                                    this.renderDownloadAction(
                                        datosLoteos[y].archivoAgua != null,
                                        () => this.descargarDocumentos(3, datosLoteos[y].id)
                                    )
                                }
                            />
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={fieldClassNames}
                                label={"Impuesto Renta Inm."}
                                inputComponent={
                                    this.renderDownloadAction(
                                        datosLoteos[y].archivoImpuestos != null,
                                        () => this.descargarDocumentos(4, datosLoteos[y].id)
                                    )
                                }
                            />
                        </div>
                    </section>
                </TabPane>
            ));
        }

        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.escribania.escribania : null)}
                submitUrl={(vars.submitType ? api.escribania.escribania : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}

                className="ui-paradigma-modal ui-loteo-modal"

                fileUploader
            >   
                <div className="ui-modal-group">
                    <p className="ui-section-label">Datos de propietarios</p>
                    <Nav tabs className="ui-modal-tabs">
                        <NavItem>
                            <NavLink
                                className={(propSelect == 1 ? 'active' : '')}
                                onClick={() => { this.setState({ propSelect: 1 }) }}
                            >Propietario 1</NavLink>
                        </NavItem>

                        {(documentosEscribania.length>=2) &&
                            <NavItem>
                                <NavLink
                                    className={(propSelect == 2 ? 'active' : '')}
                                    onClick={() => { this.setState({ propSelect: 2 }) }}
                                >Propietario 2</NavLink>
                            </NavItem>
                        }

                        {(documentosEscribania.length>=3) &&
                            <NavItem>
                                <NavLink
                                    className={(propSelect == 3 ? 'active' : '')}
                                    onClick={() => { this.setState({ propSelect: 3 }) }}
                                >Propietario 3</NavLink>
                            </NavItem>
                        }

                        {(documentosEscribania.length>=4) &&
                            <NavItem>
                                <NavLink
                                    className={(propSelect == 4 ? 'active' : '')}
                                    onClick={() => { this.setState({ propSelect: 4 }) }}
                                >Propietario 4</NavLink>
                            </NavItem>
                        }
                    </Nav>
                    <TabContent
                        activeTab={propSelect}
                        className="ui-modal-tab-content"
                    >
                        {tabPropietariosContent}
                    </TabContent>
                </div>
                
                {/*<hr/>
                <Col className="col-12 col-separator py-1 my-3">Datos de contacto</Col>

                <ParadigmaLabeledInput
                    disabled={vars.disabled}
                    md={[3, 9]}
                    maxLength={100}
                    label={"Contacto"}
                    value={contacto}
                    onChange={(e) => this.onChangeField('contacto', e.target.value)}
                    error={() => this.getError('contacto')}
                />

                <ParadigmaLabeledInput
                    disabled={vars.disabled}
                    md={[3, 9]}
                    maxLength={100}
                    label={"Domicilio"}
                    value={domicilio}
                    onChange={(e) => this.onChangeField('domicilio', e.target.value)}
                    error={() => this.getError('domicilio')}
                />*/}
                
                <div className="ui-modal-group">
                    <p className="ui-section-label">Loteos</p>
                    <Nav tabs className="ui-modal-tabs">
                        <NavItem>
                            <NavLink
                                className={(loteoSelect == 1 ? 'active' : '')}
                                onClick={() => { this.setState({ loteoSelect: 1 }) }}
                            >Lote 1</NavLink>
                        </NavItem>

                        {(datosLoteos.length>=2) &&
                            <NavItem>
                                <NavLink
                                    className={(loteoSelect == 2 ? 'active' : '')}
                                    onClick={() => { this.setState({ loteoSelect: 2 }) }}
                                >Lote 2</NavLink>
                            </NavItem>
                        }

                        {(datosLoteos.length>=3) &&
                            <NavItem>
                                <NavLink
                                    className={(loteoSelect == 3 ? 'active' : '')}
                                    onClick={() => { this.setState({ loteoSelect: 3 }) }}
                                >Lote 3</NavLink>
                            </NavItem>
                        }

                        {(datosLoteos.length>=4) &&
                            <NavItem>
                                <NavLink
                                    className={(loteoSelect == 4 ? 'active' : '')}
                                    onClick={() => { this.setState({ loteoSelect: 4 }) }}
                                >Lote 4</NavLink>
                            </NavItem>
                        }
                    </Nav>
                    <TabContent
                        activeTab={loteoSelect}
                        className="ui-modal-tab-content"
                    >
                        {tabLoteosContent}
                    </TabContent>
                </div>

                {/*<ParadigmaLabeledInput
                    md={[3, 9]}
                    label={"Loteo"}
                    error={() => this.getError('loteo_id')}
                    inputComponent={
                        <ParadigmaAsyncSeeker
                            clearable={false}
                            url={api.loteos.loteos_select}
                            parameters={{
                                paginationEnabled:false,
                                    sort:['nombre']
                            }}
                            disabled={vars.disabled}
                            value={loteo_id}
                            onChange={e=> this.setState({loteo_id: (e.id) ? (e.id) : null, error:errors})}
                        />
                    }
                />

                <ParadigmaLabeledInput
                    md={[3, 9]}
                    label={"Manzana"}
                    error={() => this.getError('manzana')}
                    value={manzana}
                    maxLength={100}
                    disabled={vars.disabled}
                    onChange={(e) => this.onChangeField('manzana', e.target.value)}
                />

                <ParadigmaLabeledInput
                    md={[3, 9]}
                    label={"Lote"}
                    error={() => this.getError('lote')}
                    value={lote}
                    maxLength={100}
                    disabled={vars.disabled}
                    onChange={(e) => this.onChangeField('lote', e.target.value)}
                />

                <ParadigmaLabeledInput
                    md={[3, 9]}
                    label={"Cert. Libre D."}
                    error={() => this.getError('certificadoLD')}
                    inputComponent={
                        <Input
                            type={'select'}
                            value={certificadoLD}
                            className="form-control"
                            disabled={vars.disabled}
                            onChange={(e) => this.onChangeField('certificadoLD', (e.target.value=='true') ? (true) : ((e.target.value=='false') ? (false) : (null)))}
                            >
                                <option value={'null'}>Seleccionar</option>
                                <option value={true}>Si</option>
                                <option value={false}>No</option>
                        </Input>}
                />

                <ParadigmaLabeledInput
                    md={[3, 9]}
                    label={"Contrato"}
                    error={() => this.getError('contrato')}
                    inputComponent={
                        <Input
                            type={'select'}
                            value={contrato}
                            disabled={vars.disabled}
                            onChange={(e) => this.onChangeField('contrato', (e.target.value=='true') ? (true) : ((e.target.value=='false') ? (false) : (null)))}
                            className="form-control"
                            >
                                <option value={'null'}>Seleccionar</option>
                                <option value={1}>Fideicomiso</option>
                                <option value={2}>Boleto de compraventa</option>
                                <option value={3}>Cesión de derechos</option>
                        </Input>}
                />

                <ParadigmaLabeledInput
                     md={[5, 7]}
                    label={"Contrato"}
                    inputComponent={
                        (nombreContrato!=null) ?
                        <Label onClick={()=>this.descargarDocumentos(1)}>{nombreContrato+' DESCARGAR'}</Label>
                        :
                        <Label>{'No esta cargado'}</Label>
                    }
                />

                <ParadigmaLabeledInput
                     md={[5, 7]}
                    label={"Archivo Municipalidad"}
                    inputComponent={
                        (nombreMunicipalidad!=null) ?
                        <Label onClick={()=>this.descargarDocumentos(2)}>{nombreMunicipalidad+' DESCARGAR'}</Label>
                        :
                        <Label>{'No esta cargado'}</Label>
                    }
                />

                <ParadigmaLabeledInput
                    md={[5, 7]}
                    label={"Archivo Agua"}
                    inputComponent={
                        (nombreAgua!=null) ?
                        <Label onClick={()=>this.descargarDocumentos(3)}>{nombreAgua+' DESCARGAR'}</Label>
                        :
                        <Label>{'No esta cargado'}</Label>
                    }
                />
            
                <ParadigmaLabeledInput
                    md={[5, 7]}
                    label={"Impuesto Renta Inm."}
                    inputComponent={
                        (nombreImpuestos!=null) ? 
                        <Label onClick={()=>this.descargarDocumentos(4)}>{nombreImpuestos+' DESCARGAR'}</Label>
                        :
                        <Label>{'No esta cargado'}</Label>
                    }
                />*/}

            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Escribania/Modal.js